import { ErrorState } from "@/design-system/ErrorState";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

interface ErrorPageInnerProps {
  labels: {
    error: string;
    solutions?: string;
  };
  content: {
    title: string;
    status: string;
    solutions: React.ReactNode[];
    image: string;
    extraInfo?: string;
  };
}

export function ErrorPageInner({ labels, content }: ErrorPageInnerProps): React.ReactNode {
  useDocumentTitle(content.title);

  return (
    <ErrorState
      title={content.title}
      status={content.status}
      errorLabel={labels.error}
      solutions={content.solutions}
      solutionsLabel={labels.solutions}
      illustration={content.image}
      extraInfo={content.extraInfo}
      data-testid="error-page"
    />
  );
}
